import React from "react";
import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const GlobalDialog = styled(Dialog)(({ theme, customWidth }) => ({
  "& .MuiDialogContent-root": {
    // padding: theme.spacing(3),
    backgroundColor: "#ffffff",
    overflowY: "visible",
    borderRadius: "20px",
  },
  "& .MuiDialogActions-root": {
    // padding: theme.spacing(2),
    justifyContent: "flex-end",
    backgroundColor: "#f9f9f9",
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
  },
  "&.MuiDialog-root .MuiDialog-container .MuiPaper-root": {
    width: customWidth || "530px",
    margin: "0",
    padding: 0,
    boxShadow: "0 8px 24px rgba(0,0,0,0.1), 0 16px 48px rgba(0,0,0,0.1)",
    borderRadius: "20px",
    // padding: theme.spacing(2.5),
    maxWidth: "calc(100% - 32px)",
    overflowY: "visible",
    transition: "all 0.3s ease-in-out",
  },
}));

const BootstrapDialog = ({ children, handleClose, open, customWidth }) => {
  return (
    <GlobalDialog
      onClose={handleClose}
      open={open}
      scroll="body"
      customWidth={customWidth}
    >
      {children}
    </GlobalDialog>
  );
};

export default BootstrapDialog;
